import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Context from "@components/useContext/context";
import helpMeEvents from "@analytics/productActions/helpme";
import Help from "@acko-tech/building-blocks.ui.header-help-modal";
import validate from "@utils/validate";
import { $primaryColorsV2 } from "@components/car/journey/mobile/styles";
import { FloatingCallback } from "@acko-tech/building-blocks.ui.header-help-modal";
import {
  helpMeFloaterClicked as helpMeFloaterIsClicked,
  helpMePopupLoaded as helpMePopupIsLoaded,
  helpMeFormSubmitted as helpMeFormIsSubmitted,
  mobileNumberEnteredHelpModal
} from "segments/eventActions/common/callBackModule";

interface Props {
  helpData: any;
  floatingCallbackCtaStyles?: any;
}

const Callback = ({ helpData, floatingCallbackCtaStyles }: Props) => {
  const { isDesktop } = useContext(Context);
  const dispatch = useDispatch();

  const {
    registeredMobileNumber,
    proposalMobileNumber,
    mobileVerified,
    isRenewal
  } = useSelector(({ indexReducer, proposalDataReducer }: any) => ({
    registeredMobileNumber: indexReducer?.mobileNumber,
    proposalMobileNumber: proposalDataReducer?.data?.mobileNumber,
    mobileVerified: proposalDataReducer?.data?.mobileVerified,
    isRenewal: proposalDataReducer?.data?.isRenewal
  }));

  const {
    helpMePopupLoaded,
    helpMeFormSubmitted,
    mobileNumberEntered,
    helpMeFloaterClicked
  } = helpMeEvents;

  const {
    screen,
    showFloatingCallbackCta
  }: { screen?: string; showFloatingCallbackCta?: boolean } = helpData;

  const desktopFloaterStyles = {
    marginRight: "3.75rem",
    ...floatingCallbackCtaStyles
  };

  const help_source = showFloatingCallbackCta ? "floater" : "header";

  return (
    <Help
      // showFloatingCallbackCta={showFloatingCallbackCta} // for showing floating callback
      // passing undefined as we made Help button (in header) by default in FloatingCallback Enum
      floatingCallback={
        showFloatingCallbackCta
          ? FloatingCallback.TALK_TO_US_CALLBACK_CTA
          : undefined
      }
      helpButtonClick={() => {
        if (showFloatingCallbackCta) {
          dispatch(
            helpMeFloaterClicked({
              edata: {
                screen: screen,
                help_source
              }
            })
          );
          dispatch(
            helpMeFloaterIsClicked({
              screen: screen,
              widget_type: help_source
            })
          );
        }
        dispatch(
          helpMePopupLoaded({
            edata: {
              screen: screen,
              help_source
            }
          })
        );
        dispatch(
          helpMePopupIsLoaded({
            screen: screen,
            help_source,
            widget_type: help_source
          })
        );
      }}
      onSubmitClick={phone => {
        dispatch(
          helpMeFormIsSubmitted({
            screen: screen,
            phone: phone,
            widget_type: help_source
          })
        );
        dispatch(
          helpMeFormSubmitted({
            edata: isRenewal
              ? {
                  screen: screen,
                  phone: phone,
                  help_source,
                  techinfo: true
                }
              : {
                  screen: screen,
                  phone: phone,
                  help_source
                },
            odata: {
              phone: proposalMobileNumber || registeredMobileNumber || phone
            }
          })
        );
      }}
      onInputBlur={phone => {
        if (!validate.phoneNumber({ phoneNumber: phone }).phoneNumber) {
          dispatch(
            mobileNumberEntered({
              edata: {
                screen: screen,
                phone: phone,
                help_source
              },
              odata: {
                phone: phone,
                mob: phone
              }
            })
          );
          dispatch(
            mobileNumberEnteredHelpModal({
              screen: screen,
              phone: phone,
              widget_type: help_source
            })
          );
        }
      }}
      validateInput={validate.phoneNumber}
      isDesktop={isDesktop}
      registeredMobileNumber={
        registeredMobileNumber || (mobileVerified && proposalMobileNumber)
      }
      proposalMobileNumber={proposalMobileNumber}
      enterDuration={200}
      exitDuration={200}
      buttonStyles={{ colorScheme: $primaryColorsV2 }}
      floatingCallbackCtaStyles={
        isDesktop ? desktopFloaterStyles : floatingCallbackCtaStyles
      }
    />
  );
};

export default Callback;
